/** Show an encounter only after the chart in the URL has loaded. */
export function encounterValueForOpenReport(
  routeReportId: number,
  loadedReportId: number | undefined,
  loadedEncounterId: string | null | undefined
): string {
  if (!routeReportId || loadedReportId !== routeReportId) return '';
  return loadedEncounterId ?? '';
}

/**
 * Sign and the report autosave write onto the report id already in the URL.
 * The form still holds the previous chart until the next one finishes loading.
 */
export function canSaveEncounterToOpenReport(
  formReportId: number | null | undefined,
  routeReportId: number
): boolean {
  return formReportId != null && formReportId === routeReportId;
}
